import { Bell, BookOpen, Newspaper, Sparkles } from "lucide-react";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
} from "../components/ui/sheet";

const mockNotifications = [
  {
    id: "n1",
    type: "course",
    title: "New Course Available",
    description: "AI Automation with Make and Zapier has been added to your learning path",
    time: "2 hours ago",
    read: false,
  },
  {
    id: "n2",
    type: "pulse",
    title: "AI Tools Update",
    description: "ChatGPT Projects feature is now available for enterprise users",
    time: "4 hours ago",
    read: false,
  },
  {
    id: "n3",
    type: "ai",
    title: "AI Coach Insight",
    description: "Based on your activity, try exploring AI workflow automation tools",
    time: "1 day ago",
    read: true,
  },
  {
    id: "n4",
    type: "course",
    title: "Course Progress",
    description: "You're 75% through 'Google AI Essentials' - keep going!",
    time: "2 days ago",
    read: true,
  },
];

const iconMap = {
  course: BookOpen,
  pulse: Newspaper,
  ai: Sparkles,
};

export const NotificationsSheet = ({ open, onOpenChange }) => {
  const unreadCount = mockNotifications.filter((n) => !n.read).length;

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="w-full sm:max-w-md bg-[#0A192F] border-l border-white/10 p-0">
        <SheetHeader className="p-6 pb-4 border-b border-white/10">
          <SheetTitle className="flex items-center gap-2 text-[#F8FAFC]">
            <Bell className="h-5 w-5 text-[#14B8A6]" />
            Notifications
            {unreadCount > 0 && (
              <span className="ml-2 px-2 py-0.5 text-xs rounded-full bg-[#14B8A6]/10 text-[#14B8A6] font-medium" data-testid="notification-badge-count">
                {unreadCount} new
              </span>
            )}
          </SheetTitle>
          <SheetDescription className="text-[#94A3B8]">
            Stay updated on new courses, AI insights, and organizational updates.
          </SheetDescription>
        </SheetHeader>

        <div className="overflow-y-auto max-h-[calc(100vh-120px)] p-4 space-y-3" data-testid="notifications-list">
          {mockNotifications.map((notification) => {
            const Icon = iconMap[notification.type] || Bell;
            return (
              <div
                key={notification.id}
                className={`group p-4 rounded-lg transition-all duration-200 cursor-pointer ${
                  notification.read
                    ? "bg-white/[0.03] hover:bg-white/[0.06]"
                    : "bg-[#14B8A6]/[0.06] hover:bg-[#14B8A6]/[0.10] border border-[#14B8A6]/10"
                }`}
                data-testid={`notification-item-${notification.id}`}
              >
                <div className="flex gap-3">
                  <div className={`w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 ${
                    notification.read
                      ? "bg-white/[0.06] text-[#94A3B8]"
                      : "bg-[#14B8A6]/10 text-[#14B8A6]"
                  }`}>
                    <Icon className="h-4 w-4" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-start justify-between gap-2">
                      <p className={`text-sm font-medium ${notification.read ? "text-[#94A3B8]" : "text-[#F8FAFC]"}`}>
                        {notification.title}
                      </p>
                      {!notification.read && (
                        <span className="w-2 h-2 rounded-full bg-[#14B8A6] flex-shrink-0 mt-1.5" />
                      )}
                    </div>
                    <p className="text-xs text-[#94A3B8] mt-1 line-clamp-2">
                      {notification.description}
                    </p>
                    <p className="text-xs text-[#94A3B8]/60 mt-2">
                      {notification.time}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </SheetContent>
    </Sheet>
  );
};
